import { TrackingService } from '../../../common/tracking/trackingService';
import { trackClickEvent } from '../../GlintsTracking/tracking';

export function trackLoginButtonClick(source: 'navbar' | 'sidebar') {
  TrackingService.logEvent('login_button_click', { source });
  trackClickEvent({
    elementName: 'login',
    properties: {
      source,
    },
  });
}

export function trackJobSeekerButtonClick(
  source: 'navbar' | 'sidebar' | 'auth_page'
) {
  TrackingService.logEvent('job_seeker_button_click', { source });
  trackClickEvent({
    elementName: 'job_seeker',
    properties: {
      source,
    },
  });
}
